import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StyxFenceDetailTitleDirective } from './detail-title.directive'

@NgModule({
    imports: [CommonModule],
    declarations: [StyxFenceDetailTitleDirective],
    entryComponents: [],
    exports: [StyxFenceDetailTitleDirective]
})
export class NgxStyxFenceModule {}
